import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';
import { useTheme } from '../../../../contexts/ThemeContext';

const CheckboxInput = ({
  value,
  onChange,
  placeholder,
  style,
  className,
  ...props
}) => {
  const { theme } = useTheme();

  return (
    <Checkbox
      checked={value || false}
      onChange={(e) => onChange?.(e.target.checked)}
      style={{
        color: theme.textSecondary,
        ...style
      }}
      className={className}
      {...props}
    >
      {placeholder}
    </Checkbox>
  );
};

CheckboxInput.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default CheckboxInput; 